function wrapFacets() {
  const quicklinksContainer = document.querySelector('.collection_quicklinks');
  const filterSortingViewbyContainer = document.querySelector('.filter-sorting-viewby');
  const facetsForm = document.querySelector('.facets__form');
  if (facetsForm) facetsForm.classList.remove('stack');

  const quicklinksWidth = quicklinksContainer?.offsetWidth || 0;
  const filterSortingViewbyWidth = filterSortingViewbyContainer?.offsetWidth || 0;
  const facetsContainerWidth = quicklinksWidth + filterSortingViewbyWidth + 50;

  const viewportWidth = document.documentElement.clientWidth;
  facetsContainerWidth > viewportWidth ? facetsForm.classList.add('stack') : facetsForm.classList.remove('stack');
}

function handleQuicklinksDrag() {
  const quicklinks = document.querySelector('.quicklinks');

  let isDown = false;
  let startX;
  let scrollLeft;
  if (quicklinks) {
    quicklinks.addEventListener('mousedown', (e) => {
      isDown = true;
      quicklinks.classList.add('dragging');
      startX = e.pageX - quicklinks.offsetLeft;
      scrollLeft = quicklinks.scrollLeft;
    });

    quicklinks.addEventListener('mouseleave', () => {
      isDown = false;
      quicklinks.classList.remove('dragging');
    });

    quicklinks.addEventListener('mouseup', () => {
      isDown = false;
      quicklinks.classList.remove('dragging');
    });

    quicklinks.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - quicklinks.offsetLeft;
      const walk = (x - startX) * 1.5;
      quicklinks.scrollLeft = scrollLeft - walk;
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  wrapFacets();
  handleQuicklinksDrag();
});
window.addEventListener('resize', function () {
  wrapFacets();
  handleQuicklinksDrag();
});



function handleCollectionFilters() {
  const filterElement = document.querySelector("#main-collection-filters");
  if (!filterElement || window.innerWidth >= 990) return;

  const stickyHeader = document.querySelector("sticky-header");
  const stickyType = stickyHeader?.getAttribute("data-sticky-type");
  const headerHidden = !!document.querySelector(".section-header.shopify-section-header-hidden");

  // Header has slid off screen. Sitting at the header offset would leave a gap.
  if (stickyType === "on-scroll-up" && headerHidden) {
    filterElement.style.transition = "none";
    filterElement.style.top = "0";
    return;
  }

  // Subtract 2px to offset the .shopify-section-header-sticky `top: -1px` rule and sub-pixel rounding,
  // so the filter sits flush with the visible bottom of the sticky header.
  const measured = stickyHeader ? stickyHeader.offsetHeight : 0;
  const raw = getComputedStyle(document.documentElement).getPropertyValue("--header-height");
  const headerHeight = measured || (raw ? parseFloat(raw) : 0);
  if (!headerHeight) return;

  filterElement.style.top = `${headerHeight - 2}px`;
}

handleCollectionFilters();
window.addEventListener("resize", handleCollectionFilters);

